import React from "react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Link } from "react-router-dom";
import appRoutes from "../../../routes/app.routes";
import { Article } from "../types";

interface ArticleCardProps {
  article: Article;
  variant?: "featured" | "featured-small" | "latest";
}

const ArticleCard = ({ article, variant = "latest" }: ArticleCardProps) => (
  <article className={`blog-article-card blog-article-card--${variant}`}>
    <Link className="blog-article-card__link" to={article.slug ? appRoutes.blogArticle.generatePath(article.slug) : appRoutes.blog.path}>
      <img
        className="blog-article-card__image"
        src={article.image}
        alt={article.title}
        loading={variant === "featured" ? "eager" : "lazy"}
      />
      <div className="blog-article-card__content">
        <span className="blog-category-label">{article.category}</span>
        <h3>{article.title}</h3>
        {article.excerpt && <p>{article.excerpt}</p>}
        {variant === "latest" ? (
          <div className="blog-article-card__meta">
            <span className="blog-author-avatar" aria-hidden="true">
              {article.author.charAt(0)}
            </span>
            <span>
              <strong>{article.author}</strong>
              <small>{article.date}</small>
            </span>
          </div>
        ) : (
          <span className="blog-read-link">
            Read More <ArrowForwardIcon fontSize="small" />
          </span>
        )}
      </div>
    </Link>
  </article>
);

export default ArticleCard;
